"use client";

import HeaderAcademy from "@/views/academy/components/header";
import ListAcademy from "@/views/academy/components/list";
import S from "./index.module.scss"

const AcademyView = () => {
  return (
    <div className={S.container}>
      <HeaderAcademy />
      <ListAcademy />
    </div>
  );
};

export default AcademyView;
